export class ReturnRates {
    savingsPlan?: number;
    onTimeSaving?: number;
}
